import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  perrental : {

  },
  alltenant : {

  }
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    saveActionResultsToState : (state , action) => {
         
        if (action.payload.action.startsWith("alltenant")){
            state.alltenant = action.payload.result
        } 
        else{
          if (!state[action.payload.action]){state[action.payload.action] = {}}
            state[action.payload.action][action.payload.id] = action.payload.result
        }
    }
  },
});

export const { saveActionResultsToState} = analyticsSlice.actions;

export default analyticsSlice.reducer;
